import {ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-button-csv',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
  <button *ngIf="active" [disabled]="loading" tabindex="0" class="{{class}}" [ngSwitch]="loading">
    <i *ngSwitchCase="false" class="fa fa-2x fa-file-excel-o text-success" placement="right" tooltip="{{title | translate}}"></i>
    <i *ngSwitchCase="true" class="fa fa-2x fa-spinner fa-pulse fa-fw text-success"></i>
  </button>
  `,
    standalone: false
})
export class ButtonCsvComponent {

  @Input() title = 'csv';

  @Input() class = 'btn btn-link';
  
  @Input() active = true;

  @Input() loading : boolean;

}

